import React, { useState, useEffect } from "react";
import ButtonComponent from "./ButtonComponent";
import { useTranslation } from "react-i18next";
import { buildFinalGSTObject, getCurrencySymbol } from "../lib/Utils";
import { getSecureItemFromSpecificStorage } from "../lib/BrowserStorageAccessMiddleware";
import { LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS } from "../assets/constants/BrowserStorageKeys";

const BookingSummary = ({
  bookingLockerHandler,
  selectedLockers,
  address,
  lockerCurrency = "INR",
  handleLockerBooking = () => {},
  is_state_gst
}) => {
  const { t } = useTranslation();
  const [updatedLockers, setUpdatedLockers] = useState(selectedLockers || []);
  const [totalPrice, setTotalPrice] = useState(0);
  const assignmentSetting = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
  
  //console.log("Locker Bank Info in BookingSummary: ", lockerBankInfo);
  console.log("Assignment Setting in BookingSummary: ", assignmentSetting);
  const collectGst = assignmentSetting?.collect_gst || false;
  const cgst_rate = assignmentSetting?.cgst_rate || 0;
  const igst_rate = assignmentSetting?.igst_rate || 0;
  const sgst_rate = assignmentSetting?.sgst_rate || 0;
  const { finalGSTObject, paymentBreakdown } = buildFinalGSTObject(totalPrice, {
    collectGst,
    isStateGst: is_state_gst,
    cgstRate: cgst_rate,
    sgstRate: sgst_rate,
    igstRate: igst_rate,
    currencyCode: lockerCurrency,
  });
  const {
    baseAmount,
    totalAmount: finalTotal,
    cgstAmount,
    sgstAmount,
    igstAmount,
  } = paymentBreakdown;
  
  console.log("collectGst in BookingSummary: ", collectGst);
  console.log("is_state_gst in BookingSummary: ", is_state_gst);
  
    
  console.log("selectedLockers in BookingSummary: ", selectedLockers);

  // Sync lockers
  useEffect(() => {
    setUpdatedLockers(selectedLockers || []);
  }, [selectedLockers]);

  const lockerList = updatedLockers || [];

  const handlerCLick = () => {
    bookingLockerHandler();
  };

  const handlePayment = () => {
    console.log(" Final Payload:", lockerList, "Total:", totalPrice);
    handleLockerBooking(lockerList, totalPrice , finalGSTObject);
  };

  // TOTAL PRICE CALCULATION (FIXED + FALLBACK)
  useEffect(() => {
    const total = lockerList.reduce((sum, item) => {
      return (
        sum +
        Number(
          item?.selectedSlot?.price ||     // selected slot price
          item?.durations?.[0]?.price ||   // fallback duration price
          item?.price || 0                 // base fallback
        )
      );
    }, 0);

    setTotalPrice(total);
  }, [lockerList]);

  return (
    <div className="booking-summary">
      <h2 className="title">
        {t("booking_summary_confirm_details_title")}
      </h2>

      <div className="location">
        {address ? address : "Pune"}
      </div>

      <div className="locker-list">
        {lockerList.map((locker) => (
          <div className="locker-card" key={locker.id}>
            <div className="locker-info">
              <span className="locker-name">{locker.name}</span>

              {/* SLOT BUTTON */}
              {locker?.bookingSlots ? (
                <button className="choose-slot-btn" disabled>
                  {locker.selectedSlot
                    ? locker.selectedSlot.durationRange
                    : t("slot_not_selected")}
                </button>
              ) : (
                <div className="time-select">
                  {locker.durations?.map((duration, index) => (
                    <p key={index}>
                      {duration.label}
                    </p>
                  ))}
                </div>
              )}

              {/* PRICE */}
              <span className="price">
                {` ${getCurrencySymbol(lockerCurrency)} `}
                {locker?.selectedSlot?.price ||
                  locker?.durations?.[0]?.price ||
                  locker?.price}
              </span>
            </div>
          </div>
        ))}

        {/* ADD LOCKER */}
        <div className="add-locker" onClick={handlerCLick}>
          {t("add_another_update_selected_locker")}
        </div>

        {/* TOTAL */}
       <div className="price-summary">
            <div className="row subtotal">
              <span className="label">Subtotal</span>
              <span className="value">
                {getCurrencySymbol(lockerCurrency)} {baseAmount.toFixed(2)}
              </span>
            </div>

            {collectGst && is_state_gst ? (
              <>
                <div className="row">
                  <span className="label">CGST ({cgst_rate}%)</span>
                  <span className="value">
                    {getCurrencySymbol(lockerCurrency)} {cgstAmount.toFixed(2)}
                  </span>
                </div>

                <div className="row">
                  <span className="label">SGST ({sgst_rate}%)</span>
                  <span className="value">
                    {getCurrencySymbol(lockerCurrency)} {sgstAmount.toFixed(2)}
                  </span>
                </div>
              </>
            ) : null}

            {collectGst && !is_state_gst ? (
              <div className="row">
                <span className="label">IGST ({igst_rate}%)</span>
                <span className="value">
                  {getCurrencySymbol(lockerCurrency)} {igstAmount.toFixed(2)}
                </span>
              </div>
            ) : null}

            <div className="divider"></div>

            <div className="row total">
              <span className="label">{t("total_payable_amount")}</span>
              <span className="value total-price">
                {getCurrencySymbol(lockerCurrency)} {finalTotal.toFixed(2)}
              </span>
            </div>
        </div>
          
         
          
      </div>

      {/* BUTTONS */}
      <div className="buttons">
        <ButtonComponent 
          type="primary" 
          handleClick={handlePayment}
          title={"proceed_to_pay"}
        />
      </div>

    </div>
  );
};

export default BookingSummary;
